import {ITableColumn} from "./table-column";
import {ITableDataItem} from "./table-data-item";

export const extractSubObjectValue = (dataItem:ITableDataItem, columnOptions:ITableColumn )=>{
    let value ='';
    if(dataItem && columnOptions){
        const subObjectKeys = columnOptions?.field?.split('.') || [];

        value = dataItem[subObjectKeys[0]];

        if(!value) {
            return '';
        }

        for (let i = 1; i< subObjectKeys.length; i++){
            value = value[subObjectKeys[i]];
            if(value == null ){
                return '';
            }
        }
    }

    return value;
};
